import { apiDelete, apiGet } from "./apiClient";

async function getCollection(path, errorMessage) {
  const res = await apiGet(path);
  if (!res.ok) return { ok: false, error: res.error ?? errorMessage, items: [] };
  return { ok: true, items: Array.isArray(res.data) ? res.data : [] };
}

export function fetchVendorsList() {
  return getCollection("/api/Vendors", "Failed to load vendors");
}

export function deleteVendor(id) {
  return apiDelete(`/api/Vendors/${id}`);
}

export function fetchVendorAddressesList() {
  return getCollection("/api/VendorAddresses", "Failed to load vendor addresses");
}

export function deleteVendorAddress(id) {
  return apiDelete(`/api/VendorAddresses/${id}`);
}
